import React, { FC, useEffect, useMemo, useRef, useState } from 'react';
import { Container, BanksLogo } from '../../../landing.common';
import { MainForm } from '../main.form';
import { useSelection } from '../../../../store/reducers/selection';
import { PAGE } from '../../../../constants';
import { Title } from './components/title';
import { TopForm } from './components/top.form';
import { HowToSelect } from './components/how.to.select';
import { Benefits } from './components/benefits';
import styles from './content.module.scss';

type Props = {
    showLanding: boolean;
    setShowLanding: (v: boolean) => void;
};

export const LandingContent: FC<Props> = ({ setShowLanding, showLanding }) => {
    const mainFormAnchorRef = useRef<HTMLDivElement>(null);
    const [isMainFormVisible, setIsMainFormVisible] = useState(false);
    const { page } = useSelection();
    const showLandingContent = useMemo(() => showLanding && page === PAGE.CARDS_LANDING, [showLanding, page]);

    const setMainFormVisibility = (value: boolean) => {
        if (isMainFormVisible !== value) {
            updateMainFormVisibility(value);
        }
    };

    const updateMainFormVisibility = (value: boolean) => setIsMainFormVisible(value);

    const scrollHandler = () => {
        const mainForm = mainFormAnchorRef.current;
        if (mainForm) {
            const { y: positionY } = mainForm.getBoundingClientRect();
            if (positionY > 10) {
                setMainFormVisibility(false);
            } else {
                setMainFormVisibility(true);
            }
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', scrollHandler);
        return () => {
            window.removeEventListener('scroll', scrollHandler);
        };
    }, [isMainFormVisible]);

    return (
        <>
            {showLandingContent && (
                <>
                    <Container>
                        <Title />
                        <TopForm isMainFormVisible={isMainFormVisible} />
                    </Container>
                    <BanksLogo className={styles['banks-logos']} />
                </>
            )}

            <Container clearStyles={!showLandingContent}>
                {showLandingContent && (
                    <>
                        <HowToSelect />
                        <Benefits />
                    </>
                )}
                <MainForm ref={mainFormAnchorRef} showLanding={showLanding} setShowLanding={setShowLanding} />
            </Container>
        </>
    );
};
